// One place for the business details shown across the site.
// The legal name must match the D-U-N-S record exactly (Apple checks it).
export const company = {
    legalName: 'ALEXANDER CLOUD CONSULTANT',
    displayName: 'Alexander Cloud Consultant',
    japaneseName: 'アレキサンダークラウドコンサルティング',
    founder: 'Jelani Alexander',
    location: 'Aichi, Japan',
    logo: '/logo512.png',
    linkedinCompany: 'https://www.linkedin.com/company/alexander-cloud-consulting/',
    email: 'jelani@alexandercloudconsultant.com',
    linkedin: 'https://www.linkedin.com/in/jelani-alexander/',
    github: 'https://github.com/AlexJelani',
};

export const janetsLight = {
    name: "Janet's Light",
    tagline: 'Catch it early. Keep shining.',
    icon: '/apps/janets-light/icon.png',
    supportEmail: company.email,
    policyDate: 'November 4, 2026',
};
